import { FunctionComponent, InputHTMLAttributes, useRef } from 'react';
import styled from 'styled-components';
import { Icon } from './icon';

export const SelectInput: FunctionComponent<TSelectInput> = ({
  label,
  ...props
}) => {
  const ref = useRef<any>(null);

  return (
    <Container className="select-input" onClick={() => ref.current?.focus()}>
      <label>{label}</label>

      <select {...props} ref={ref} />

      <Icon name="arrow-down" color="white" size={28} />
    </Container>
  );
};

const Container = styled.div`
  background: #262f40;
  width: 100%;
  padding: 8px 16px;
  margin-bottom: 13px;
  position: relative;

  label {
    display: block;
    color: #8092b2;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.1em;
    margin-bottom: 8px;
    pointer-events: none;
    text-align: left;
  }

  select {
    appearance: none;
    width: 100%;
    background: none;
    font-size: 16px;
    line-height: 24px;
    font-weight: bold;
    outline: none;
    color: white;

    option {
      background: #262f40;
      color: white;
    }

    &::placeholder {
      color: rgba(255, 255, 255, 0.2);
      font-weight: 300;
    }
  }

  .icon-arrow-down {
    position: absolute;
    pointer-events: none;
    right: 14px;
    bottom: 16px;
  }
`;

type TSelectInput = InputHTMLAttributes<any> & {
  label: string;
};
